import React from 'react'
import { ActionIcon } from '@mantine/core'
import { IconBrandYoutube } from '@tabler/icons-react'

/**
 * Renders the Youtube link.
 * @param {string} url The Youtube URL.
 * @param {string} color The text color for the button.
 * @returns {JSX.Element}
 */
function YoutubeIcon ({ url, color }) {
  return (
    <ActionIcon
      variant='filled'
      color={color}
      aria-label='Youtube'
      size='sm'
      component='a'
      href={url}
      target='_blank'
      autoContrast
    >
      <IconBrandYoutube stroke={2} aria-label='Follow on Youtube' />
    </ActionIcon>
  )
}

export default React.memo(YoutubeIcon)
